import { render, staticRenderFns } from "./CustomerViewOrders.vue?vue&type=template&id=4baead00&scoped=true"
import script from "./CustomerViewOrders.vue?vue&type=script&lang=js"
export * from "./CustomerViewOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baead00",
  null
  
)

export default component.exports